import axiosClient from "./axiosClient";

export const getStudentsOfClassroom = async (selectedClassroomId, selectedDate) => {
  const response = await axiosClient.get("/Manager/Absence/GetStudentsOfClassroom/" + selectedClassroomId + "/" + selectedDate);
  return response.data;
};

export const getStudentById = async (studentId) => {
  const response = await axiosClient.get("/Manager/Absence/GetStudentById/" + studentId);
  return response.data;
};

export const insertStudent = async (classroomId, name, family, parentMobile) => {
  const response = await axiosClient.post("/Manager/Absence/InsertStudent/" + classroomId, { name, family, parentMobile });
  return response.data;
};

export const updateStudent = async (studentId, name, family, parentMobile) => {
  const response = await axiosClient.put("/Manager/Absence/UpdateStudent/" + studentId, { name, family, parentMobile });
  return response.data;
};

export const deleteStudent = async (studentId) => {
  const response = await axiosClient.delete("/Manager/Absence/DeleteStudent/" + studentId);
  return response.data;
};